const React = require('react');

const Container = require('../common/Container.jsx');
const Content = require('../common/Content.jsx');
const Name = require('../utility/Name.jsx');
const _Signature = require('../common/Signature.jsx');
const Token = require('../utility/Token.jsx');
const _TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region SIGNATURE

function Signature(props) {
    const data = props.data || {};
    const config = props.config || {};
    let blockProps = {};
    let includes = {};
    if (config.Config) {
        if (config.Config.Block) {
            blockProps = config.Config.Block;
        }
        if (config.Config.Includes) {
            includes = config.Config.Includes;
        }
    }

    let styleDate = {};
    if (includes.Date) {
        styleDate = Utilities.Config.getStyle(data, blockProps, 'Date', { textAlign: 'right' });
    }
    let lineColor;
    if (blockProps.lineColor) {
        lineColor = blockProps.lineColor;
    } else {
        lineColor = Utilities.Config.getBodyStyle(data).color;
    }
    const styleLabelCompany = Utilities.Config.getStyle(data, blockProps, 'CompanyLabel');
    styleLabelCompany.marginBottom = undefined;
    if (!Utilities.isNullOrWhitespace(blockProps.lineSpacingCompanyLabel)) {
        styleLabelCompany.paddingTop = blockProps.lineSpacingCompanyLabel;
    }
    const styleLabelDate = Utilities.Config.getStyle(data, blockProps, 'DateLabel', { textAlign: 'right' });
    styleLabelDate.marginBottom = undefined;
    if (!Utilities.isNullOrWhitespace(blockProps.lineSpacingDateLabel)) {
        styleLabelDate.paddingTop = blockProps.lineSpacingDateLabel;
    }
    const styleLabelName = Utilities.Config.getStyle(data, blockProps, 'NameLabel');
    styleLabelName.marginBottom = undefined;
    if (!Utilities.isNullOrWhitespace(blockProps.lineSpacingNameLabel)) {
        styleLabelName.paddingTop = blockProps.lineSpacingNameLabel;
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragStart={props.onDragStart}>
            <tr>
                <td colSpan={2} style={{ borderBottom: `1px solid ${lineColor}`, textAlign: 'right' }}>
                    {
                        includes.Date &&
                        <div style={styleDate}>{data.Date}</div>
                    }
                </td>
            </tr>
            <tr>
                <Content.ValueWrapperCell style={styleLabelName}>
                    {
                        blockProps.signatureType == 'recipient' &&
                        data.RecipientName
                    }
                    {
                        blockProps.signatureType == 'sender' &&
                        data.SenderName
                    }
                    {props.builder && Utilities.Builder.dragOutline()}
                </Content.ValueWrapperCell>
                {
                    includes.DateLabel &&
                    <Content.ValueWrapperCell style={styleLabelDate}>{blockProps.textDateLabel}</Content.ValueWrapperCell>
                }
            </tr>
            {
                blockProps.signatureType == 'sender' &&
                data.IsSender &&
                includes.Company &&
                data.Gallery &&
                <tr>
                    <Content.ValueWrapperCell colSpan={2} style={styleLabelCompany}>{data.Gallery.Company}</Content.ValueWrapperCell>
                </tr>
            }
        </Container>
    );
}

const TypeConfig = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    {
                        display: 'Signature Type',
                        name: 'signatureType',
                        options: [
                            { display: 'Recipient', value: 'recipient' },
                            { display: 'Sender', value: 'sender' }
                        ],
                        type: 'dropdown',
                        value: 'recipient'
                    },
                    {
                        display: 'Signature Line Color',
                        name: 'lineColor',
                        type: 'text'
                    },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Date Properties', id: 'dateProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'Date' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    {
                        display: 'Recipient Name Label Properties',
                        id: 'nameLabelProps',
                        type: 'header',
                        visible: function (config) {
                            return config.Block && config.Block.signatureType == 'recipient';
                        }
                    },
                    {
                        display: 'Sender Name Label Properties',
                        id: 'nameLabelProps',
                        type: 'header',
                        visible: function (config) {
                            return config.Block && config.Block.signatureType == 'sender';
                        }
                    },
                    ..._TypeConfig.options.text({ name: 'NameLabel' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    {
                        display: 'Company Label Properties',
                        id: 'companyLabelProps',
                        type: 'header',
                        visible: function (config) {
                            return config.Block && config.Block.signatureType == 'sender';
                        }
                    },
                    ..._TypeConfig.options.text({ name: 'CompanyLabel', visible: function (config) { return config.Block && config.Block.signatureType == 'sender'; } }, {}, {}, {}),
                    {
                        type: 'spacer',
                        visible: function (config) {
                            return config.Block && config.Block.signatureType == 'sender';
                        }
                    },
                    {
                        type: 'spacer',
                        visible: function (config) {
                            return config.Block && config.Block.signatureType == 'sender';
                        }
                    },
                    { display: 'Date Label Properties', id: 'dateLabelProps', type: 'header' },
                    {
                        display: 'Display Text',
                        name: 'textDateLabel',
                        type: 'text',
                        value: 'Date'
                    },
                    { type: 'spacer' },
                    ..._TypeConfig.options.text({ name: 'DateLabel' }, {}, undefined, {})
                ]
            };
        },
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'Date Label', name: 'DateLabel', type: 'checkbox', value: true },
                    { display: 'Date', name: 'Date', type: 'checkbox', value: true },
                    {
                        display: 'Company',
                        name: 'Company',
                        type: 'checkbox',
                        value: true,
                        visible: function (config) {
                            return config.Block && config.Block.signatureType == 'sender';
                        }
                    }
                ]
            };
        },
        style: function () { return _TypeConfig.panel.layoutStyle(); }
    }
};

// #endregion SIGNATURE

// #region SIGNATURE V2

const SignatureV2 = Content.withLabelTokenParsing(
    _Signature.V2.Component,
    (props, keyword, options) => {
        const data = props.data || {};
        let replaceString = '';
        switch (keyword) {
            case Token.CompanyName:
                if (data.IsSender && data.Gallery && !Utilities.isNullOrWhitespace(data.Gallery.Company)) {
                    replaceString = Token.getReplacementString(data.Gallery.Company, options);
                }
                break;
            case Token.Date:
                replaceString = Token.getReplacementString(data.Date, options);
                break;
            case Token.RecipientName:
                if (!Utilities.isNullOrWhitespace(data.RecipientName)) {
                    replaceString = Token.getReplacementString(data.RecipientName, options);
                }
                break;
            case Token.SenderName:
                if (!Utilities.isNullOrWhitespace(data.SenderName)) {
                    replaceString = Token.getReplacementString(data.SenderName, options);
                }
                break;
            default:
                replaceString = undefined;
                break;
        }
        return replaceString;
    },
    { allowEmptyContent: true }
);
const TokensSignature = () => [
    Token.getWrappedTokenConfig('Date', Token.Date),
    Token.getWrappedTokenConfig('Recipient Name', Token.RecipientName),
    Token.getWrappedTokenConfig('Sender Name', Token.SenderName),
    Token.getWrappedTokenConfig('Sender Company', Token.CompanyName)
];

const TypeConfigV2 = {
    panel: {
        block: _Signature.V2.TypeConfig.panel.block,
        description: () => _Signature.V2.TypeConfig.panel.description(Utilities.wrapTextForEditor({ text: `{${Token.RecipientName}("before":"","after":"")}`, token: Token.RecipientName })),
        label: _Signature.V2.TypeConfig.panel.label,
        style: _Signature.V2.TypeConfig.panel.style,
        value: () => _Signature.V2.TypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":"","after":"")}`, token: Token.Date }))
    }
}

// #endregion SIGNATURE V2

module.exports = {
    Component: Signature,
    TypeConfig,

    V2: {
        Component: SignatureV2,
        Tokens: TokensSignature,
        TypeConfig: TypeConfigV2
    }
};